document.addEventListener(
    "DOMContentLoaded", () => {
        // Contents from DOM
        let close = document.querySelector("#mmenuContents .close").textContent;
        let languagenav = document.querySelector("#header .quickAccess__languageSwitcher");
        let searchUrl = document.querySelector('#js-header-search-form').action;

        new Mmenu("#header__navigation--mobile", {
            "extensions": [
                "fullscreen",
                "position-top",
                "theme-white"
            ],
            "navbars": {
                "content": [
                    "prev",
                    "<a href='" + searchUrl + "'><img src='/typo3conf/ext/templates/Resources/Public/Icons/search.svg' /></a>",
                    "<a class='mm-btn mm-navbar__btn mm-btn_close' href='#mm-0'><img src='/typo3conf/ext/templates/Resources/Public/Icons/cross.svg' /></a>"
                ]
            }
        });

    }
);